import { Component, Input } from '@angular/core';
import { CallLogResponse } from '../../../models/responses/call-log-response';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CallLogService } from '../../../services/call-log.service';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-call-log-view',
  standalone: true,
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgIf,
    FormsModule,
    MatInputModule
  ],
  templateUrl: './call-log-view.component.html',
  styleUrl: './call-log-view.component.scss'
})
export class CallLogViewComponent {
  @Input() callLog!: CallLogResponse;
  isLoading: boolean = false;

  constructor(
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
    private callLogService: CallLogService,
    private snackBar: MatSnackBar
  ) { }

  onBackClicked() {
    this.aiConfigurationPageEventsService.onCallLogViewBackedClickedEvent.emit();
  }

  formatDate(date: Date) {
    return new Date(date).toString().replace(/GMT.*$/, '').trim();
  }

  onRemoveClicked() {
    this.isLoading = true;

    this.callLogService.removeById(this.callLog.id).subscribe({
      next: () => {
        this.aiConfigurationPageEventsService.onCallLogViewDeletedEvent.emit();
        this.snackBar.open('Call log deleted successfully', 'Close', { duration: 5000 });
        this.isLoading = false;
      },
      error: () => {
        alert('Server error, contact support');
        this.isLoading = false;
      }
    })
  }
}
